<template>
  <div class="min-h-full">
    <main class="py-10">
      <!-- Page header -->
      <div class="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
        <div class="flex items-center space-x-5">
          <div class="flex-shrink-0">
            <div class="relative">
              <img
                class="h-10 w-14 object-cover"
                :src="engagement.place.image"
                :alt="engagement.place.name"
              >
              <span
                class="absolute inset-0 shadow-inner rounded-full"
                aria-hidden="true"
              />
            </div>
          </div>
          <div>
            <h1 class="text-2xl font-bold text-gray-900">
              {{ engagement.place.name }}
            </h1>
            <p class="text-sm font-medium text-gray-500">
              {{ engagement.place.area }}
            </p>
          </div>
        </div>
        <div class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3">
          <button
            v-if="offers.length > 0"
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
            @click="showAcceptOfferModal = true"
          >
            Accept offers
          </button>
          <button
            v-else
            type="button"
            class="disabled inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-600 bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
            disabled
          >
            Accept offers
          </button>
        </div>
      </div>

      <div class="mt-8 max-w-3xl mx-auto grid grid-cols-1 sm:px-6 lg:max-w-7xl">
        <div class="space-y-6">
          <!-- Description list-->
          <section aria-labelledby="applicant-information-title">
            <div class="bg-white shadow sm:rounded-lg">
              <div class="px-4 py-5 sm:px-6">
                <h2
                  id="applicant-information-title"
                  class="text-lg leading-6 font-medium text-gray-900"
                >
                  Engagement Information
                </h2>
                <p class="mt-1 max-w-2xl text-sm text-gray-500">
                  Information regarding the guide engagement
                </p>
              </div>
              <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
                <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                  <div class="sm:col-span-2">
                    <dt class="text-sm font-medium text-gray-500">
                      Description
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ engagement.description }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      Starts at
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      <FormattedTime :date="engagement.starts_at" />
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      Ends at
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      <FormattedTime :date="engagement.ends_at" />
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      Pax
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ engagement.pax }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      Project manager
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 flex items-center">
                      <div class="h-5 w-5 flex-shrink-0">
                        <img
                          class="h-5 w-5 rounded-full object-cover"
                          :src="engagement.user.profile_photo_url"
                          :alt="engagement.user.name"
                        >
                      </div>
                      <div class="ml-1">
                        <div class="text-sm text-gray-900">
                          {{ engagement.user.name }}
                        </div>
                      </div>
                    </dd>
                  </div>
                  <div class="sm:col-span-2">
                    <dt class="text-sm font-medium text-gray-500">
                      Booked guides
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 flex items-center grid grid-cols-3 gap-3">
                      <article
                        v-for="request in booked"
                        class="col-span-3 lg:col-span-2 xl:col-span-1 bg-gray-100 rounded-lg flex justify-between"
                      >
                        <Link
                          :href="route('engagements.requests.show', {engagementRequest: request.id})"
                          class="flex items-center p-5"
                        >
                          <div class="h-10 w-10 flex-shrink-0">
                            <img
                              class="h-10 w-10 rounded-full object-cover"
                              :src="request.guide_profile.user.profile_photo_url"
                              :alt="request.guide_profile.user.name"
                            >
                          </div>
                          <div class="ml-4">
                            <div class="font-medium text-gray-900">
                              {{ request.guide_profile.user.name }}
                            </div>
                            <div class="text-gray-500">
                              {{ request.guide_profile.team.name }}
                            </div>
                          </div>

                        </Link>
                              <div @click="openAddGuideReviewModal(request.guide_profile)" v-if="request.guide_profile.reviews.length === 0" class="flex flex-col text-center p-5 cursor-pointer text-primary hover:text-primary-dark">
                                  <span>Leave</span>
                                  <span>a review</span>
                              </div>
                              <div v-else class="flex flex-col justify-center items-center text-xs m-4">
                                  <span>Your rating:</span>
                                  <star-rating :rating="request.guide_profile.reviews[0].rating" :read-only="true" :star-size="14" :show-rating="false"></star-rating>
                                  <span  @click="openAddGuideReviewModal(request.guide_profile)" class="cursor-pointer text-primary hover:text-primary-dark">update</span>
                              </div>
                      </article>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </section>
          <h3>Requested guides</h3>
          <div class="mt-8 flex flex-col">
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                  <table class="min-w-full divide-y divide-gray-300">
                    <thead class="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                        >
                          Guide
                        </th>
                        <th
                          scope="col"
                          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Messages
                        </th>
                        <th
                          scope="col"
                          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        >
                          <span class="sr-only">View</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-200 bg-white">
                      <tr
                        v-for="request in unbooked"
                        v-if="unbooked.length > 0"
                      >
                        <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6">
                            <div class="flex items-center">
                            <div class="h-10 w-10 flex-shrink-0">
                              <img
                                class="h-10 w-10 rounded-full object-cover"
                                :src="request.guide_profile.user.profile_photo_url"
                                :alt="request.guide_profile.user.name"
                              >
                            </div>
                            <div class="ml-4">
                              <div class="font-medium text-gray-900">
                                {{ request.guide_profile.user.name }}
                              </div>
                              <div class="text-gray-500">
                                {{ request.guide_profile.team.name }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {{ request.comments.length }}
                        </td>
                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          <span
                            v-if="typeof request.offer_made_at === 'undefined'"
                            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
                          > Pending </span>
                          <span
                            v-else-if="request.offer_made_at !== null"
                            class="inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800"
                          > Offer given {{ request.offer.currency.symbol }} {{ request.offer.amount }}</span>
                          <span
                            v-else-if="request.expired"
                            class="inline-flex rounded-full px-2 text-xs font-medium leading-5 bg-red-100 text-red-800"
                          > Expired </span>
                          <span
                            v-else-if="request.declined_at !== null"
                            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
                          > Declined </span>
                          <span
                            v-else
                            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
                          > Pending </span>
                        </td>
                        <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <Link
                            :href="route('engagements.requests.show', {engagementRequest: request.id})"
                            class="text-indigo-600 hover:text-indigo-900"
                          >
                            View
                          </Link>
                        </td>
                      </tr>
                      <tr
                        v-else
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        <td colspan="4">
                          <p class="p-5 text-center text-gray-500 text-sm">
                            No requests to show
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    class="text-center w-full py-4 bg-green-500 hover:bg-green-400 text-white"
                    @click="showNewRequestModal = true"
                  >
                    {{ engagement.requests.length > 0 ? 'Request more guides' : 'Request a guide' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <FindGuideModal
      :show="showNewRequestModal"
      :engagement="engagement"
      :genders="genders"
      :payment_options="payment_options"
      @close="showNewRequestModal = false"
      @request="addRequest($event)"
    />
  </div>
  <AcceptOfferModal
    :show="showAcceptOfferModal"
    :engagement="engagement"
    @close="showAcceptOfferModal = false"
  />
    <AddGuideReviewModal
      :show="showAddGuideReviewModal"
      @close="showAddGuideReviewModal = false"
      :engagement="engagement"
      :guide="guide_for_review"
    />
</template>

<script>
import {Link} from '@inertiajs/vue3'
import FindGuideModal from '@/ComponentsDeprecated/Modal/FindGuideModal';
import FormattedTime from '@/ComponentsDeprecated/Time/FormattedTime';
import AcceptOfferModal from '@/ComponentsDeprecated/Modal/AcceptOfferModal';
import AddGuideReviewModal from "@/ComponentsDeprecated/Modal/AddGuideReviewModal";
import StarRating from "vue-star-rating";

export default {
  name: 'Show',
  components: { AcceptOfferModal, FormattedTime, FindGuideModal, AddGuideReviewModal, StarRating, Link },
  props: {
    engagement: {
      required: true,
      type: Object,
    },
    genders: {
      type: Object,
      required: true,
    },

    payment_options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showNewRequestModal: false,
      showAcceptOfferModal: false,
      showAddGuideReviewModal: false,
      guide_for_review: null
    };
  },
    computed: {
    booked() {
      return this.engagement.requests.filter((r) => (r.offer ? r.offer.booked_at !== null : false));
    },
    unbooked() {
      return this.engagement.requests.filter((r) => (r.offer ? r.offer.booked_at === null : true));
    },
    offers() {
      return this.unbooked.filter((r) => !!r.offer);
    },
  },
  methods: {
    addRequest(e) {
      this.engagement.requests.push({ ...e });
    },
    openAddGuideReviewModal(guide) {
        this.guide_for_review = guide;
        this.showAddGuideReviewModal = true;
    }
  },
};
</script>

<style scoped>

</style>
